import mapFunction from './mapResources';

export default mapFunction('reward_multipliers', {
    isFetching: false,
    items: [] 
});